import React from "react";
import { useSelector } from "react-redux";
import { Loading } from "../../../Helper/Loading";
import LabelOCR from "./LabelOCR";

export default function LabelPicture() {
  const user = useSelector(state => state.auth.user);

  if (typeof user.center === "undefined" || typeof user.center.system === "undefined") {
    return <Loading />;
  }

  const side = user.center.system + "-label";

  return (
    <LabelOCR
      title="Label Picture"
      side={side}
      nextStep="validate_label"
      prevStep="home"
    />
  );
}

